import { Helmet }            from 'react-helmet';
import DetailView            from 'components/view/DetailView';
import { useTranslation }    from 'react-i18next';
import { handleResult }      from 'utils/utils';
import { Box, }              from '@mui/material';
import { useQuery }          from '@apollo/client';
import { useParams }         from 'react-router';
import NotFound              from 'pages/NotFound';
import { useNotifier }       from 'hooks/notification';
import { useConfig }         from 'hooks/config';
import { GET_DETAIL_VIEW }   from 'queries/detail';
import ViewLayout            from 'components/view/ViewLayout';
import { getEnabledLinks }   from 'components/view/utils/links';
import DetailBreadcrumbs     from 'components/breadcrumbs/DetailBreadcrumbs';
import RenderContextProvider from 'contexts/RenderContext';
import { useTranslator }     from 'hooks/translator';
import StickyBannerLayout    from 'components/layout/common/StickyBannerLayout';
import DetailInfoProvider    from 'contexts/DetailContext';
import LayoutDetailView from 'components/view/LayoutDetailView';

const DetailPage = () => {
  const {t}         = useTranslation()
  const { project } = useConfig()
  const { id: detailId, detail: detailKey } = useParams()

  return (
    <>
      <Helmet>
        <title>{t('detail')} | {project}</title>
      </Helmet>
      <RenderContextProvider context="detail" props={{ detailKey, detailId }}>
        <DetailResult detailKey={detailKey} detailId={detailId}/>
      </RenderContextProvider>
    </>
  )
}

const DetailResult = ({ detailKey, detailId }) => {
  const result   = useQuery(GET_DETAIL_VIEW, { variables: { detailKey, detailId } })
  const notifier = useNotifier()
  // TODO translate label
  const {translator} = useTranslator()

  return handleResult(result, notifier,
    data => {
      const label = data.detail.instance.label
      return <DetailInfoProvider id={detailId} detail={detailKey} label={label}>
        <DetailContents schema={data.detail.schema}
                        sections={data.detail.instance.enabledSectionKeys}
                        links={getEnabledLinks(data.detail.instance.links)}
                        stencil={data.detail.stencil}/>
      </DetailInfoProvider>
    },
    error => {
      console.error("GraphQL error: %o", error); return <NotFound/>
    }
  )
}

const DetailContents = ({ schema, sections, links, stencil }) =>
  <ViewLayout links={links}>
    <StickyBannerLayout banner={<DetailBreadcrumbs /> } >
      <Box sx={{display: "flex", width: "100%", padding: "20px"}}>
        { _.isEmpty(stencil)
          ? <DetailView schema={schema} sections={sections}/>
          : <LayoutDetailView schema={schema} sections={sections} stencil={stencil}/>
        }
      </Box>
    </StickyBannerLayout>
  </ViewLayout>

export default DetailPage
